<template>
 <!--  <div class="jobvite-job">
    <router-link to="/" class="jobvite-btn">Back</router-link>
    <h1 class="job-title">{{ job.title }}</h1>
    <div class="job-btn"> <a :href="job.applyLink" class="job-btn-link"> Start your application </a> </div>
    <div class="job-description">
      <strong>Job Title</strong>: {{ job.title }}<br>
      <strong>Department</strong>: {{ job.department }}<br><br>
      <strong>Location</strong>:<br>
      <strong>Office Name</strong>: {{ job.jobLocations[0].name }}<br>
      <strong>Address</strong>: {{ job.jobLocations[0].address }}<br>
      <strong>City</strong>: {{ job.jobLocations[0].city }}<br>
      <strong>Postal code</strong>: {{ job.jobLocations[0].postalCode }}<br>
      <strong>Country</strong>: {{ job.jobLocations[0].country }}<br><br>

      <strong>Description</strong>: <div v-html="job.description"></div>
    </div>
    <div class="job-btn"> <a :href="job.applyLink" class="job-btn-link"> Start your application </a> </div>

    <router-link to="/" class="jobvite-btn">Back</router-link>
  </div> -->
  <div>
  <router-link to="/" class="jobvite-btn btn">Back</router-link>
  <b-card :title="job.title">
   <b-button :href="job.applyLink" variant="outline-primary" class="float-right job-btn-link">Start your application </b-button>
   <br>
   
    <b-card-text>
   <b-list-group flush>
      <b-list-group-item> <strong>Job Title</strong>: {{ job.title }}</b-list-group-item>
      <b-list-group-item><strong>Department</strong>: {{ job.department }}</b-list-group-item>
      <b-list-group-item><strong>Location</strong>:<br>
      <strong>Office Name</strong>: {{ job.jobLocations[0].name }}<br>
      <strong>Address</strong>: {{ job.jobLocations[0].address }}<br>
      <strong>City</strong>: {{ job.jobLocations[0].city }}<br>
      <strong>Postal code</strong>: {{ job.jobLocations[0].postalCode }}<br>
      <strong>Country</strong>: {{ job.jobLocations[0].country }}<br><br></b-list-group-item>
      <b-list-group-item>  <strong>Description</strong>: <div v-html="job.description"></div></b-list-group-item>
      
    </b-list-group>
    </b-card-text>
   <b-button :href="job.applyLink" variant="outline-primary" class="float-right job-btn-link">Start your application </b-button>

  </b-card>
  <router-link to="/" class="jobvite-btn btn">Back</router-link>

</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'Job',
  computed: {
    ...mapGetters(['JOBS']),
    job() {
      for(let job of this.JOBS) {
        if(job.eId === this.$route.params.id) {
          return job
        }
      }
      return false
    },
  },

  methods: {
    ...mapActions(['GET_JOBS_FROM_API']),
  },

  created() {
    if(!this.JOBS.length) {
      this.GET_JOBS_FROM_API()
    }
  }
}
</script>

<style>
.jobvite-joblist-container .job-btn-link{
float: right;
}
.jobvite-joblist-container .job-btn{
 height: 40px;
    padding-top: 20px;
}
.jobvite-joblist-container .jobvite-job {
  text-align: left;
}
.jobvite-joblist-container .jobvite-job * {
  font-size: 14px !important;
}
.jobvite-joblist-container .job-title {
  font-size: 25px !important;
}
.jobvite-joblist-container .jobvite-btn {
  display: inline-block;
  padding: 5px 15px;
  margin-top: 10px;
  margin-bottom: 10px;
  border: 1px solid #444;
  color: white;
  background: #444;
  text-decoration: none;
  cursor: pointer;
  transition: all .2s;
}
.jobvite-joblist-container .jobvite-btn:before {
  content: '\2190';
  font-size: 20px;
  margin-right: 10px;
}
.jobvite-joblist-container .jobvite-btn:hover {
  background: #555;
}
</style>
